module.exports = __webpack_public_path__ + "static/media/zealix-5.9ec23d67.jpg";